/**
 * Copyright © SoftServe, Inc. All rights reserved.
 *
 * @license proprietary (Non-free Software License)
 */

export const FIELD_TYPE = {
    email: 'email',
    text: 'text',
    number: 'number',
    radio: 'radio',
    checkbox: 'checkbox',
    textarea: 'textarea',
    password: 'password',
    select: 'select',
    file: 'file',
    multi: 'multi',
    date: 'date',
    datePicker: 'date-picker',
    time: 'time',
    dateTime: 'datetime-local',
    submit: 'submit',
    button: 'button'
};

export default FIELD_TYPE;
